import React from 'react'

import './Products.scss'

const ProductR = (props) => {
  return (
        <div className="product__details">
            {/* Show image on mobile only */}
            <img src={props.image} alt="Image" className='mob__show'/>

            <div className="product_details">
                <h2 className='section__subheading'>{props.heading}</h2>
                <article>{props.description}</article>
                <a href={props.buttonRef} className='btn product__actionbtn'>{props.buttonText}</a>
            </div>

            {/* Show image on tab and pc */}
            <img src={props.image} alt="Image" className='mob__hide'/>
        </div>
  )
}

export default ProductR